/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

// Alias
import Tooltip from '../tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./components/popover-tooltip/index.jsx